import { createRoute, Outlet } from '@tanstack/react-router'
import { rootRoute } from './__root'
import { TabLayout } from '@/components/layout/TabLayout'

export const publicWithTabsRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: '_publicWithTabs',
  component: () => (
    <TabLayout>
      <Outlet />
    </TabLayout>
  ),
})
